module.exports = __webpack_public_path__ + "img/interactive.bdeec7a5.jpg";